import React from "react";

import ColdIcon from "../icons/ColdIcon";
import ConversionIcon from "../icons/ConversionIcon";
import HotIcon from "../icons/HotIcon";
import NewLeadsIcon from "../icons/NewLeadsIcon";
import QualifiedIcon from "../icons/QualifiedIcon";
import ScoreIcon from "../icons/ScoreIcon";
import TotalLeadsIcon from "../icons/TotalLeadsIcon";
import WarmIcon from "../icons/WarmIcon";
import WonLeadsIcon from "../icons/WonLeadsIcon";

export const getScoreColor = (score: number): string => {
  switch (true) {
    case score < 5:
      return "#D03124";
    case score < 8:
      return "#E87722";
    case score >= 8:
      return "#4CB66B";
    default:
      return "#9e9e9e"

  }
}

export const getStatusStyle = (status: string) => {
  switch (status) {
    case "qualified":
    case "proposal":
    case "negotiation":
      return {
        backgroundColor: "#E87722",
        color: "white",
        borderRadius: "12px",
        fontWeight: 500
      };
    case "contacted":
      return {
        backgroundColor: "#f5f5f5",
        color: "#666",
        borderRadius: "12px",
        fontWeight: 500,
        border: "1px solid #ddd"
      };
    case "won":
      return {
        backgroundColor: "#4cb66b",
        color: "white",
        borderRadius: "12px",
        fontWeight: 500
      };
    case "lost":
      return {
        backgroundColor: "#d03124",
        color: "white",
        borderRadius: "12px",
        fontWeight: 500
      };
    case "new":
      return {
        backgroundColor: "transparent",
        color: "#333",
        fontWeight: 500
      };
    default:
      return {
        backgroundColor: "#e0e0e0",
        color: "#333",
        borderRadius: "12px",
        fontWeight: 500
      };
  }
};

export const iconMapping = (key:string, props?: { width?: number; height?: number; fill?: string }) =>{
  const defaultProps = { width: 40, height: 40, ...props };
  
  switch(key){
    case "totalLeads":
      return React.createElement(TotalLeadsIcon, defaultProps);
    case "newLeads":
      return React.createElement(NewLeadsIcon, defaultProps);
    case "qualified":
      return React.createElement(QualifiedIcon, defaultProps);
    case "conversionRate":
      return React.createElement(ConversionIcon, defaultProps);
    case "wonDeals":
    case "wonLeads":
      return React.createElement(WonLeadsIcon, defaultProps);
    case "score":
      return React.createElement(ScoreIcon, defaultProps);
    case "hot":
      return React.createElement(HotIcon, defaultProps);
    case "warm":
      return React.createElement(WarmIcon, defaultProps);
    case "cold":
      return React.createElement(ColdIcon, defaultProps);
    default:
      return null
  }

}

export const getQualificationText = (score: number) => {
  if (score >= 1 && score <= 4) return "Cold";
  if (score >= 5 && score <= 7) return "Warm";
  if (score >= 8 && score <= 10) return "Hot";
  return "";
};

  export const formatNumber = (num: number) => {
    if (num >= 1000000000) {
      const value = (num / 1000000000).toFixed(1);
      return value.endsWith(".0") ? value.slice(0, -2) + "B" : value + "B";
    }
    if (num >= 1000000) {
      const value = (num / 1000000).toFixed(1);
      return value.endsWith(".0") ? value.slice(0, -2) + "M" : value + "M";
    }
    if (num >= 1000) {
      const value = (num / 1000).toFixed(1);
      return value.endsWith(".0") ? value.slice(0, -2) + "K" : value + "K";
    }
    return num.toString();
  };

